<template>
  <div class="reservation absolute">
    <div class="whiteBg">
      <div class="nav acea-row">
        <div class="item font-color-red">
          <i class="iconfont icon-yuyuetixing"></i>
          预约提货
        </div>
      </div>
      <div class="list">
        <form @submit.prevent="submit">
          <div class="item">
            <div>
              <i class="iconfont icon-card icon"></i>
              <input
                type="text"
                placeholder="请输入卡号"
                v-model="cardNumber"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                type="password"
                placeholder="请输入卡劵提货密码"
                v-model="password"
                required
              />
            </div>
          </div>
        </form>
      </div>
      <div class="submit" @click="submit" v-if="!loading">下一步</div>
      <div class="nosubmit" v-else>下一步</div>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<script>
import { verifyCard, getAnnouncement, getGiftTicket } from "@api/giftticket";
import attrs, { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { encrypt } from "@/utils/jsencrypt";

export default {
  name: "ReservationTicket",
  data: function() {
    return {
      cardNumber: "",
      password: "",
      loading: false,
      announcement: ""
    };
  },
  mounted: function() {
    this.getTicketAnnouncement();
  },
  methods: {
    async submit() {
      this.loading = true;
      const { cardNumber, password } = this;
      try {
        await this.$validator({
          cardNumber: [required(required.message("卡号"))],
          password: [required(required.message("提货密码"))]
        }).validate({ cardNumber, password });
      } catch (e) {
        this.loading = false;
        return validatorDefaultCatch(e);
      }
      let params = {
        code: cardNumber,
        password: encrypt(password)
      };

      verifyCard(params)
        .then(res => {
          if (res.data.status === 0) {
            this.$dialog.error("该卡劵不存在，请重新输入卡号");
            this.loading = false;
          } else if (res.data.status === 1) {
            this.$dialog.error("提货密码不正确，请重新输入");
            this.loading = false;
          } else if (res.data.status === 2) {
            //已使用
            this.$dialog.toast({ mes: "该卡劵已使用" });
            // 定时器（设置时间2s）
            setTimeout(() => {
              this.loading = false;
              this.$router.push({
                path: "/giftticket/result/" + this.cardNumber
              });
            }, 2000);
          } else if (res.data.status === 3) {
            //未使用/使用中/已过期
            this.$dialog.success("验证成功");
            // 定时器（设置时间2s）
            setTimeout(() => {
              this.loading = false;
              this.$router.push({
                path: "/giftticket/detail/" + this.cardNumber
              });
            }, 2000);
          }
        })
        .catch(e => {
          console.log(e);
          this.$dialog.error(e.msg);
          this.loading = false;
        });
    },
    reset() {
      this.cardNumber = "";
      this.password = "";
    },
    getTicketAnnouncement() {
      getAnnouncement().then(res => {
        this.announcement = res.data;
        if (res.data) {
          this.$vantDialog.alert({
            title: "公告",
            message: res.data,
            messageAlign: "left"
          });
        }
      });
    }
  }
};
</script>
